import React from 'react';
import Slider from 'react-slick';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './GalleryCarousel.css';
import lipBlush from '../../Assets/Gallery/lip_blush.jpg';
import pmu from '../../Assets/Gallery/pmu.jpg';
import powderBrow from '../../Assets/Gallery/Powder_Brow.jpg';
import touchUp from '../../Assets/Gallery/Touch_Up.jpg';
import combinationBrow from '../../Assets/Gallery/Combination_Brow.jpg';
import microblading from '../../Assets/Gallery/Microblading.jpg';
import browDaddy from '../../Assets/Gallery/BROW_DADDY.png';
import pmuAngel from '../../Assets/Gallery/pmuangel.jpg';
import corona from '../../Assets/Gallery/Corona.jpg';
import riverside from '../../Assets/Gallery/Riverside.jpg';
import brows from '../../Assets/Gallery/brows.jpg';
import eyebrow from '../../Assets/Gallery/eyebrow.jpg';
import permanent from '../../Assets/Gallery/Permanent.jpg';
import semi from '../../Assets/Gallery/Semi.jpg';
import tattoo from '../../Assets/Gallery/tattoo.jpg';
import technique from '../../Assets/Gallery/technique.jpg';

const images = [
  { src: lipBlush, alt: 'Lip blush result' },
  { src: pmu, alt: 'PMU brows result' },
  { src: powderBrow, alt: 'Powder brows result' },
  { src: touchUp, alt: 'Touch up result' },
  { src: combinationBrow, alt: 'Combination brow result' },
  { src: microblading, alt: 'Microblading result' },
  { src: browDaddy, alt: 'Brow styling work' },
  { src: pmuAngel, alt: 'Detailed PMU result' },
  { src: corona, alt: 'Corona beauty studio work' },
  { src: riverside, alt: 'Riverside PMU work' },
  { src: brows, alt: 'Brows close-up' },
  { src: eyebrow, alt: 'Eyebrow result' },
  { src: permanent, alt: 'Permanent makeup result' },
  { src: semi, alt: 'Semi permanent makeup result' },
  { src: tattoo, alt: 'Cosmetic tattoo result' },
  { src: technique, alt: 'Technique close-up' },
];

function ArrowButton({ onClick, direction }) {
  return (
    <button
      type="button"
      className={`gallery-carousel__arrow gallery-carousel__arrow--${direction}`}
      onClick={onClick}
      aria-label={direction === 'next' ? 'Next slide' : 'Previous slide'}
    >
      {direction === 'next' ? <FaArrowRight /> : <FaArrowLeft />}
    </button>
  );
}

export default function GalleryCarousel() {
  const settings = {
    infinite: true,
    speed: 450,
    lazyLoad: 'ondemand',
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <ArrowButton direction="next" />,
    prevArrow: <ArrowButton direction="prev" />,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="gallery-carousel">
      <Slider {...settings}>
        {images.map((image) => (
          <div key={image.alt} className="gallery-carousel__slide-wrap">
            <div className="gallery-carousel__slide">
              <img src={image.src} alt={image.alt} loading="lazy" />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
